import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/i18n";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import OurWork from "@/pages/OurWork";
import ProgramDetail from "@/pages/ProgramDetail";
import Dhamma from "@/pages/Dhamma";
import Leadership from "@/pages/Leadership";
import Nalanda from "@/pages/Nalanda";
import Media from "@/pages/Media";
import MahaKaruna from "@/pages/MahaKaruna";
import Donate from "@/pages/Donate";
import Volunteer from "@/pages/Volunteer";
import Contact from "@/pages/Contact";

const SmoothScroll = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
  return null;
};

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App">
      <img
        src="/assets/dhamma-chakra.png"
        alt=""
        aria-hidden="true"
        className="global-chakra"
        data-testid="global-chakra"
      />
      <LangProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main id="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/about/journey" element={<About />} />
              <Route path="/our-work" element={<OurWork />} />
              <Route path="/our-work/:slug" element={<ProgramDetail />} />
              <Route path="/dhamma" element={<Dhamma />} />
              <Route path="/leadership" element={<Leadership />} />
              <Route path="/nalanda" element={<Nalanda />} />
              <Route path="/media" element={<Media />} />
              <Route path="/media/photos" element={<Media scrollTo="photos" />} />
              <Route path="/media/videos" element={<Media scrollTo="videos" />} />
              <Route path="/maha-karuna" element={<MahaKaruna />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/donate/bank-details" element={<Donate initialTab="bank-transfer" />} />
              <Route path="/donate/receipt" element={<Donate initialTab="receipt" />} />
              <Route path="/volunteer" element={<Volunteer />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
